import React from "react"
import classes from "./ResultSet.module.css"
import { useTranslation } from "react-i18next"

const fieldnames = ["Idx", "Ability", "Seed", "Update"]
const ResultSet = props => {
    const { t } = useTranslation()

    const headlines = [
        t("misc:Common.Slot"),
        t("translation:LayoutMsg.Cmn_CstBase_00.001"),
        t("misc:Checker.ResultSeedAfterRoll"),
        t("misc:Checker.ResultUpdateSeed"),
    ]
    const header = headlines.map((v, idx) => (
        <th key={idx} className={classes.TableHead}>
            {v}
        </th>
    ))
    let body = (
        <tr className={classes.ContentNotFound}>
            <td colSpan={headlines.length}>{t("misc:Checker.ResultNoResults")}</td>
        </tr>
    )
    if (props.results.length > 0) {
        body = props.results.map((entry, idx) => {
            return (
                <tr key={idx} className={(idx & 1) === 0 ? classes.TDEven : classes.TDOdd}>
                    {fieldnames.map((v, i) => {
                        if (v === "Update") {
                            return (
                                <td key={idx + "." + i}>
                                    <button
                                        className={classes.Button}
                                        onClick={() => props.updateSeed(props.results[idx]["Seed"], false)}
                                    >
                                        {t("misc:Checker.ButtonUpdateSeed")}
                                    </button>
                                    {props.currentGear.Label === "None" ? null : (
                                        <button
                                            className={classes.Button}
                                            onClick={() => props.updateSeed(props.results[idx]["Seed"], true)}
                                        >
                                            {t("misc:Checker.ButtonUpdateAndSave")}
                                        </button>
                                    )}
                                </td>
                            )
                        } else {
                            return <td key={idx + "." + i}>{props.results[idx][v]}</td>
                        }
                    })}
                </tr>
            )
        })
    }
    return (
        <div className={classes.Wrapper}>
            <table className={classes.Table}>
                <thead>
                    <tr>{header}</tr>
                </thead>
                <tbody>{body}</tbody>
            </table>
        </div>
    )
}

export default React.memo(ResultSet)
